export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'container',
              name: 'Container Topo',
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columns1'
                }
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
            },
          },
          view: {
      
          },
    };
  
    return component;
  };

  